console.log("VERSION 6 LIVE");

const SUPABASE_URL = "https://vuextytsvwidyczrgioi.supabase.co";

const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ1ZXh0eXRzdndpZHljenJnaW9pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkwNzExOTYsImV4cCI6MjA5NDY0NzE5Nn0.CUlj8lsNJ6TLPN0n7a9xyiyRhv_OPlbGkZy4CotOUog";

document.addEventListener("DOMContentLoaded", function () {

  const form = document.getElementById("agentScopeForm");

  if (!form) {
    console.error("Form not found");
    return;
  }

  form.addEventListener("submit", async function (e) {
    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn.disabled) return;

submitBtn.disabled = true;
submitBtn.innerText = "Uploading files (this may take a moment)...";
    e.preventDefault();

    console.log("FORM SUBMIT FIRED");
    const submissionId = crypto.randomUUID();

    console.log("SUBMISSION ID:", submissionId);

const fileInput = document.getElementById("scopeFiles");
const uploadedFiles = [];
const uploadedFileNames = [];

if (fileInput && fileInput.files.length > 0) {

  for (const file of fileInput.files) {

    const fileName = `${submissionId}/${Date.now()}-${file.name}`;

    console.log("UPLOADING FILE:", fileName);

    const uploadResponse = await fetch(
      `${SUPABASE_URL}/storage/v1/object/agent-scope-files/${fileName}`,
      {
        method: "POST",
        headers: {
          "apikey": SUPABASE_ANON_KEY,
          "Authorization": `Bearer ${SUPABASE_ANON_KEY}`,
          "Content-Type": file.type
        },
        body: file
      }
    );

    if (!uploadResponse.ok) {
  const errorText = await uploadResponse.text();

  console.error("FILE UPLOAD FAILED:", errorText);

  throw new Error("File upload failed. Submission stopped.");
}

    const publicUrl =
      `${SUPABASE_URL}/storage/v1/object/public/agent-scope-files/${fileName}`;

    uploadedFiles.push(publicUrl);

    uploadedFileNames.push(file.name);
  }
}
await new Promise(resolve => setTimeout(resolve, 400));
submitBtn.innerText = "Submitting request...";
    const payload = {
      agency_name: form.querySelector('[name="agency_name"]').value,
      contact_name: form.querySelector('[name="contact_name"]').value,
      submission_id: submissionId,
      uploaded_files: uploadedFiles,
      uploaded_file_names: uploadedFileNames,
      email: form.querySelector('[name="email"]').value,
      phone: form.querySelector('[name="phone"]').value,
      property_address: form.querySelector('[name="property_address"]').value,
      suburb: form.querySelector('[name="suburb"]').value,
      property_type: form.querySelector('[name="property_type"]').value,
      property_status: form.querySelector('[name="property_status"]').value,
      service_objective: form.querySelector('[name="service_objective"]').value,
      settlement_date: form.querySelector('[name="settlement_date"]').value,
      scope_notes: form.querySelector('[name="scope_notes"]').value
    };

    console.log("PAYLOAD:", payload);

    try {

      const response = await fetch(
  SUPABASE_URL + "/rest/v1/agent_scope_requests",
  {
    method: "POST",
    headers: {
      "apikey": SUPABASE_ANON_KEY,
      "Authorization": `Bearer ${SUPABASE_ANON_KEY}`,
      "Content-Type": "application/json",
      "Prefer": "return=representation",
      "Content-Profile": "public"
    },
    body: JSON.stringify(payload)
  }
);

      const result = await response.text();

      console.log("SUPABASE RESPONSE:", response.status, result);

      if (!response.ok) {
        alert("Submission failed");
        return;
      }
submitBtn.innerText = "Submitted ✓";
const shortId = submissionId.split("-")[0];

const successMessage = document.getElementById("successMessage");

if (successMessage) {
  successMessage.innerHTML = `
    <div style="padding:12px 0;">
      <strong>✓ Request submitted successfully</strong><br><br>
      Reference ID: <code>${shortId}</code><br>
      We’ll review your scope shortly.
    </div>
  `;
}
      document.getElementById("successMessage").style.display = "block";

      form.reset();
      setTimeout(() => {
  submitBtn.disabled = false;
  submitBtn.innerText = "Submit Request";
}, 2500);

    } catch (error) {

      console.error("FETCH ERROR:", error);

    }

  });

});